/**
 * Validated environment access.
 *
 * Server-only secrets are read from `process.env` at runtime; client-facing
 * values must be prefixed with NEXT_PUBLIC_ so Next.js inlines them at build.
 */

function withFallback(value: string | undefined, fallback: string): string {
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

// Each `process.env.NEXT_PUBLIC_*` below MUST be a literal, static member
// access — that is the only form Next.js replaces with the real value at
// build time. A dynamic lookup like `process.env[name]` is NOT substituted
// and silently collapses to the fallback in the browser bundle.
export const env = {
  API_URL: withFallback(process.env.NEXT_PUBLIC_API_URL, 'http://localhost:8000'),
  WS_URL: withFallback(process.env.NEXT_PUBLIC_WS_URL, 'ws://localhost:8000'),
  POSTHOG_KEY: withFallback(process.env.NEXT_PUBLIC_POSTHOG_KEY, ''),
  POSTHOG_HOST: withFallback(process.env.NEXT_PUBLIC_POSTHOG_HOST, 'https://us.i.posthog.com'),
} as const;

export type Env = typeof env;
